export class attachment {
	constructor (attachmentDomElement) {
		this.attachment = attachmentDomElement;
		this.init();
	}
	init(){
		
		this.inputFile = this.attachment.querySelector('input[type="file"]');
		this.paragraph = this.attachment.querySelector('[data-attachmentName]');
		this.addLabel = this.attachment.querySelector('[data-addAttachment]');
		this.removeFile = this.attachment.querySelector('[data-removeAttachment]');

		this.inputFile.addEventListener('change', () => {
			let addedFileName = this.inputFile.value;

			addedFileName = (typeof addedFileName === 'string' && (addedFileName = addedFileName.match(/[^\\\/]+$/)) && addedFileName[0]) || '';
			this.paragraph.innerHTML = addedFileName;
			this.addLabel.style.display = 'none';
			this.removeFile.style.display = 'inline-block';
		});

		this.removeFile.addEventListener('click', () => {
			this.inputFile.value = '';
			this.paragraph.innerHTML = '';
			this.addLabel.style.display = 'block';
			this.removeFile.style.display = 'none';
		});
	}
}

class attachmentList {
	constructor () {}
	init ($root = document) {
		this.attachmentDomElements = $root.querySelectorAll('[data-attachment]');
		this.attachmentArr = [];
		[].forEach.call(this.attachmentDomElements, (el) => {
			this.attachmentArr.push(new attachment(el));
		});
	}
}

const attachments = new attachmentList();
export { attachments };
